import MuiEditIcon from '@mui/icons-material/DriveFileRenameOutlineRounded';
import MuiSaveCopyIcon from '@mui/icons-material/PermMediaRounded';
import MuiSaveIcon from '@mui/icons-material/Save';
import Dialog from '@mui/material/Dialog';
import { Button } from 'components/Button';
import FilerobotImageEditor from 'react-filerobot-image-editor';
import styled from 'styled-components';

export const SaveIcon = styled(MuiSaveIcon)`
  color: ${({ theme }) => theme.customPalette?.primary[500]} !important;
`;

export const SaveCopyIcon = styled(MuiSaveCopyIcon)`
  color: ${({ theme }) => theme.customPalette?.primary[500]} !important;
`;

export const EditIcon = styled(MuiEditIcon)`
  width: 20px !important;
  height: 19px !important;
`;

export const EditButton = styled(Button)`
  background-color: rgba(47, 47, 47, 0.7) !important;
  color: #fff !important;
  &:hover {
    background-color: rgba(47, 47, 47, 0.9) !important;
  }
`;

export const Container = styled(Dialog)`
  z-index: 1100 !important;

  .MuiModal-root {
    z-index: 1100;

    .MuiDialog-root {
      z-index: 1100;
    }
  }

  .MuiDialog-container {
    z-index: 1100;
  }

  .MuiPaper-root {
    display: flex;
    width: 100%;
    height: 100%;
    max-width: 100vw;
    max-height: 100vh;
    z-index: 1100;
    margin: 0;
  }
`;

export const Editor = styled(FilerobotImageEditor).attrs(({ theme: { customPalette, typography } }) => ({
  theme: {
    palette: {
      'accent-primary': customPalette?.primary[500],
      'accent-primary-hover': customPalette?.primary[500],
      'accent-primary-active': customPalette?.primary[500],
      'accent-stateless': customPalette?.primary[500],
      'bg-primary-active': customPalette?.primary[50],
      'borders-secondary': customPalette?.primary[100],
      'icons-primary': customPalette?.primary[500],
    },
    typography: {
      fontFamily: typography?.fontFamily,
    },
  },
}))``;
